/* eslint-disable react-hooks/exhaustive-deps */

import { React, useContext, useEffect, useState } from 'react'
import App from '../../layout/App';
import {
  FormContent, Container, Box,
  Select, Option, TitleFieldForm,
  Box3Items, Box2Items, BoxInput,
  Box50, Box25, Box30,
  Box40, Box10, Box75, Message,
  Madatory
} from '../../styles/styles'
import { useNavigate } from 'react-router';

import Checkbox from '../../Components/checkbox'
import Loading from '../../Components/Loading';
import InputResponsive1 from '../../Components/InputResponsive1';
import '../../styles/styles.css';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import api from '../../utils/api';
import apiAux from '../../utils/apiAux'
import './styles.css'
import { celularMask, cepMask, cnpjMask, telephoneMask } from '../../utils/mask';
import MessagePopUp from '../../Components/messagePopUp';
import { IsNone, resetValues } from '../../utils/functions';
import InfoForm from '../../Components/infoForm';
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { escolaJson } from '../../utils/objectJson';
import { validationForm1 } from '../../utils/validationSchool';
import { useIndexedLabels } from '../../utils/useIndexedLabels';

function IdentificacaoEscola() {
  const {
    getIndexByLabel,
  } = useIndexedLabels();
  const [messageRequired, setMessageRequired] = useState([])
  const [removeLoad, setRemoveLoad] = useState(true)
  const [ies, setIes] = useState([]);
  const navigation = useNavigate();
  const { setErrorMessage } = useContext(MessageContext);
  const [CityDetails, setCityDetails] = useState('')
  const [District, setDistrict] = useState(0)
  const [DDD, setDDD] = useState('')
  const [optionNumber, setOptionNumber] = useState(1)

  const [IdentificacaoEscola, setIdentificacaoEscola] = useState(escolaJson)
  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(validationForm1),
    mode: 'onChange'
  });

  const onSubmit = data => {
    setRemoveLoad(false)
    setTimeout(function () {
      sessionStorage.setItem('EscolaEditar', JSON.stringify(IdentificacaoEscola))
      if (sessionStorage.getItem('Escola') !== '' || localStorage.getItem('Escola') !== undefined) {
        setRemoveLoad(true)
        navigation('/escola/editar-caracterizacao')
      }
    }, 500);
  };

  async function getCep() {
    let test = cepMask(IdentificacaoEscola?.address.cep)
    if (test?.length === 9) {
      await apiAux.get(test + '/json/').then(function (response) {
        setCityDetails(response.data)
        setIdentificacaoEscola({
          ...IdentificacaoEscola, uf: response.data.uf, address: {
            ...IdentificacaoEscola?.address, city: response.data.ibge
          }
        })
        api.get('/resource/district/list/' + response.data.ibge).then((resp) => {
          setDistrict(resp.data)
          setIdentificacaoEscola({
            ...IdentificacaoEscola, uf: response.data.uf, address: {
              ...IdentificacaoEscola?.address, city: response.data.ibge,
              district: (resp.data[0].id % 100).toString().padStart(2, '0')
            }
          })
        }).catch((err) => {
        })
      })
    }
  }

  useEffect(() => {
    const inep = sessionStorage.getItem("inep")
    api.get('school/' + inep).then(async function (response) {
      setIdentificacaoEscola(response.data);
    }).catch((err) => {
      setErrorMessage([{ message: "Erro ao buscar escola", ok: false }])
    })
    api.get('resource/ies/list').then((response) => {
      setIes(response.data)
    }).catch(() => {
    })
    api.get("resource/ddd/list").then((response) => {
      setDDD(response.data)
    })
    setRemoveLoad(true)
  }, [0])

  useEffect(() => {
    getCep()
  }, [IdentificacaoEscola?.address?.cep])

  useEffect(() => {
    if (errors) {
      const entries = Object.entries(errors).map(([key, error]) => ({
        id: key + '-' + error.message,
        fieldName: key,
        error,
      }));
      setMessageRequired(entries);
    }
  }, [errors]);


  return (
    <>
      {!removeLoad && <Loading />}
      <div className='span-message'>
        {messageRequired.map(({ id, fieldName, error }) => {
          const idx = getIndexByLabel(fieldName) || "";
          const text = error.message;

          return (
            <MessagePopUp
              key={id}
              title={`Campo ${idx} - obrigatório`}
              text={text}
              onClose={() =>
                setMessageRequired(prev => prev.filter(m => m.id !== id))
              }
            />
          );
        })}
      </div>
      <App>
        <Container>
          <InfoForm
            title={'Escola'}
            wasChanged={IdentificacaoEscola?.wasChanged}
            positionPagination={'1/3'}
            subtitle={'Identificação'}
          />
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormContent>
              <Box3Items>
                <Box30>
                  <InputResponsive1
                    disabled
                    title='1 - codigo inep'
                    type='number'
                    name='codeInep'
                    {...setValue('codeInep', IdentificacaoEscola?.codeInep ?? 0)}
                    register={register('codeInep')}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, codeInep: e.target.value })}
                    erro={errors.codeInep?.message} />
                </Box30>
              </Box3Items>
              <Box2Items>
                <Box30 className='right'>
                  <TitleFieldForm>
                    2 - situação de funcionamento <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Select
                    name='workingSituation'
                    register={register('workingSituation')}
                    {...setValue('workingSituation', IdentificacaoEscola?.workingSituation ?? 0)}
                    value={IdentificacaoEscola?.workingSituation ?? 0}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, workingSituation: Number(e.target.value) })}>
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={1}>Em atividade</Option>
                    <Option value={2}>Paralizada</Option>
                    <Option value={3}>Extinta</Option>
                  </Select>
                  <Message>{errors.workingSituation?.message}</Message>
                </Box30>
                <Box30 className='right' style={{ display: Number(IdentificacaoEscola?.workingSituation) === 1 ? 'block' : 'none' }} >
                  <InputResponsive1
                    name='startDate'
                    register={register('startDate')}
                    type='date' title='2a - Ano letivo (inicio)'
                    {...setValue('startDate', IdentificacaoEscola?.startDate ?? null)}
                    value={IdentificacaoEscola?.startDate ?? '2000-01-01'}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, startDate: e.target.value })}
                    erro={errors.startDate?.message} />
                </Box30>
                <Box30 style={{ display: Number(IdentificacaoEscola?.workingSituation) === 1 ? 'block' : 'none' }}>
                  <InputResponsive1
                    name='finishDate'
                    register={register('finishDate')}
                    type='date'
                    title="2b - Ano letivo-término (Previsão)"
                    setValue={setValue('finishDate', IdentificacaoEscola?.finishDate ?? null)}
                    value={IdentificacaoEscola?.finishDate ?? '2001-01-01'}
                    disabled={Number(IdentificacaoEscola?.workingSituation) === 1 ? false : true}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, finishDate: e.target.value })}
                    erro={errors.finishDate?.message} />
                </Box30>
              </Box2Items>
              <Box>
                <InputResponsive1
                  name='name'
                  mandatory='*'
                  register={register('name')}
                  type='text'
                  title='3 - Nome da escola'
                  maxlength='100'
                  {...setValue('name', IdentificacaoEscola?.name ?? '')}
                  value={IdentificacaoEscola?.name || ''}
                  onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, name: e.target.value.toUpperCase() })}
                  erro={errors.name?.message} />
              </Box>
              <Box2Items>
                <Box10 className='right'>
                  <InputResponsive1
                    name='cep'
                    register={register('cep')}
                    title="4 - CEP"
                    maxlength='9'
                    mandatory='*'
                    value={cepMask(IdentificacaoEscola?.address.cep) ?? ''}
                    {...setValue('cep', cepMask(IdentificacaoEscola?.address.cep))}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address,
                        cep: e.target.value
                      }
                    })}
                    erro={errors.cep?.message} />
                </Box10>
                <Box10 className='right'>
                  <TitleFieldForm>UF</TitleFieldForm>
                  <Select
                    name='uf'
                    register={register('uf')}
                    {...setValue('uf', IdentificacaoEscola?.uf ?? 0)}
                    title="5 - UF"
                    disabled
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, uf: e.target.value
                    })}>
                    <option>{CityDetails.uf}</option>
                  </Select>
                </Box10>
                <Box30 className='right'>
                  <TitleFieldForm>Município</TitleFieldForm>
                  <Select
                    name='city'
                    register={register('city')}
                    disabled
                    {...setValue('city', IdentificacaoEscola?.address.city ?? null)}
                    value={IdentificacaoEscola?.address.city ?? 0}
                    title="6 - Município"
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address, city: e.target.value
                      }
                    })}
                    erro={errors.city?.message}
                  >
                    <option>{CityDetails.localidade}</option>
                  </Select>
                </Box30>
                <Box30>
                  <TitleFieldForm>Distrito<Madatory>*</Madatory></TitleFieldForm>
                  <Select
                    name='district'
                    register={register('district')}
                    title="7 - Distrito"
                    value={IdentificacaoEscola?.address.district ?? 0}
                    {...setValue('district', IdentificacaoEscola?.address.district ?? 0)}
                    erro={errors.district?.message}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address, district: (e.target.value % 100).toString().padStart(2, '0')
                      }
                    })} >
                    {District !== 0 ? District.map((item, index) => {
                      return <option key={index} value={item.id}>{item.name}</option>
                    }) : ""}
                  </Select>
                </Box30>
              </Box2Items>
              <Box2Items>
                <Box className='right'>
                  <InputResponsive1
                    name='publicPlace'
                    mandatory='*'
                    register={register('publicPlace')}
                    title="8 - Endereço"
                    erro={errors.publicPlace?.message}
                    {...setValue('publicPlace', IdentificacaoEscola?.address.publicPlace ?? '')}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address, publicPlace: e.target.value
                      }
                    })} />
                </Box>
                <Box25>
                  <InputResponsive1
                    name='number'
                    onkeypress="if (!isNaN(String.fromCharCode(window.event.keyCode))) return true; else return false;"
                    register={register('number')}
                    title="9 - Número "
                    maxlength='10'
                    erro={errors.number?.message}
                    value={IdentificacaoEscola?.address.number ?? 0}
                    {...setValue('number', IdentificacaoEscola?.address.number ?? 0)}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address, number: e.target.value
                      }
                    })} />
                </Box25>
              </Box2Items>
              <Box2Items>
                <Box className='right'>
                  <InputResponsive1
                    name='complement'
                    register={register('complement')}
                    title="10 - complemento "
                    maxlength='20'
                    value={IdentificacaoEscola?.address.complement ?? ''}
                    erro={errors.complement?.message}
                    {...setValue('complement', IdentificacaoEscola?.address.complement ?? 0)}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address, complement: e.target.value
                      }
                    })} />
                </Box>
                <Box>
                  <InputResponsive1
                    name='neighborhood'
                    register={register('neighborhood')}
                    title="11 - Bairro "
                    maxlength='50'
                    value={IdentificacaoEscola?.address.neighborhood ?? ''}
                    erro={errors.neighborhood?.message}
                    {...setValue('neighborhood', IdentificacaoEscola?.address.neighborhood ?? 0)}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, address: {
                        ...IdentificacaoEscola?.address, neighborhood: e.target.value
                      }
                    })} />
                </Box>
              </Box2Items>
              <TitleFieldForm>
                Contato
              </TitleFieldForm>
              <Box3Items className='box-radio'>
                <input type='radio' className='radio' name='optionNumber' {...register('optionNumber')} {...setValue('optionNumber', optionNumber ?? 0)} title='Sim' id="yes" value={1} onChange={(e) => setOptionNumber(1)} checked={Number(optionNumber) === 1} /><label className='info-radio'>Telefone-fixo</label>
                <input type='radio' className='radio' name='optionNumber' {...register('optionNumber')}  {...setValue('optionNumber', optionNumber ?? 0)} title='Não' id="no" value={2} onChange={(e) => setOptionNumber(2)} checked={Number(optionNumber) === 2} /> <label className='info-radio'>Celular</label>
              </Box3Items>
              <Box3Items>
                <Box10 className="right">
                  <TitleFieldForm>
                    12 - DDD
                  </TitleFieldForm>
                  <Select
                    name='ddd'
                    maxlength='2'
                    register={register('ddd')}
                    {...setValue('ddd', IdentificacaoEscola?.telephone?.ddd ?? -1)}
                    value={IdentificacaoEscola?.telephone?.ddd ?? 0}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, telephone: {
                        ...IdentificacaoEscola?.telephone,
                        ddd: e.target.value
                      }
                    })}
                    disabled={String(IdentificacaoEscola?.telephone?.mainPhone).length > 9 || String(IdentificacaoEscola?.telephone?.secondaryPhone).length > 9 ? false : true}>
                    <Option value={-1} disabled hidden>selecione</Option>
                    {Object.values(DDD).map((item, index) => {
                      return <Option key={index} value={item.number}>{item.number}</Option>;
                    })}
                  </Select>
                  <Message>{errors.ddd?.message}</Message>
                </Box10>

                <Box25 className='right'>
                  <InputResponsive1
                    name='telephone'
                    register={register('telephone')}
                    title="13 - telefone"
                    //    {...setValue('telephone', IdentificacaoEscola?.telephone.number ?? 0)}
                    erro={errors.telephone?.message}
                    value={optionNumber === 1 ? telephoneMask(IdentificacaoEscola?.telephone?.mainPhone) : celularMask(IdentificacaoEscola?.telephone?.main)
                    }
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, telephone: {
                        ...IdentificacaoEscola?.telephone,
                        mainPhone: e.target.value
                      }
                    })} />
                </Box25>
                <Box25 className='right'>
                  <InputResponsive1
                    name='telephone2'
                    register={register('telephone2')}
                    title="13a - outro telefone "
                    //    {...setValue('telephone', IdentificacaoEscola?.telephone.number ?? 0)}
                    erro={errors.telephone?.message}
                    value={optionNumber === 1 ? telephoneMask(IdentificacaoEscola?.telephone?.secondaryPhone) : celularMask(IdentificacaoEscola?.telephone?.secondaryPhone)
                    }
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, telephone: {
                        ...IdentificacaoEscola?.telephone,
                        secondaryPhone: e.target.value
                      }
                    })} />
                </Box25>
              </Box3Items>
              <BoxInput>
                <Box3Items>
                  <Box75>
                    <InputResponsive1
                      name='email'
                      register={register('email')}
                      maxlength='50'
                      erro={errors.email?.message}
                      value={IdentificacaoEscola?.email ?? ''}
                      {...setValue('email', IdentificacaoEscola?.email ?? '')}
                      title="15 - Endereço eletronico(e-mail) da escola"
                      onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, email: e.target.value })} />
                  </Box75>
                </Box3Items>
                <InputResponsive1
                  name='codeTeachingBody'
                  register={register('codeTeachingBody')}
                  title="16 - Codigo do Orgão regional de ensino"
                  maxlength='5'
                  value={IdentificacaoEscola?.codeTeachingBody ?? ''}
                  {...setValue('codeTeachingBody', IdentificacaoEscola?.codeTeachingBody ?? 0)}
                  erro={errors.codeTeachingBody?.message}
                  onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, codeTeachingBody: e.target.value })} />

                <Box>
                  <TitleFieldForm>
                    17 - Localização/Zona da escola <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Select
                    name='schoolZone'
                    register={register('schoolZone')}
                    {...setValue('schoolZone', IdentificacaoEscola?.schoolZone ?? 0)}
                    defaultValue={IdentificacaoEscola?.schoolZone ?? 0}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, schoolZone: e.target.value })}>
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={1}>Urbana</Option>
                    <Option value={2}>Rural</Option>
                  </Select>
                  <Message>{errors.schoolZone?.message}</Message>
                </Box>
                <Box3Items>
                  <Box40>
                    <TitleFieldForm>
                      18 - Local de funcionamento diferenciado da escola <Madatory>*</Madatory>
                    </TitleFieldForm>
                    <Select
                      name='localizationSchool'
                      {...register('localizationSchool')}
                      {...setValue('localizationSchool', IdentificacaoEscola?.localizationSchool ?? 0)}
                      onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, localizationSchool: e.target.value })}
                    >
                      <Option value={0} disabled hidden>selecione</Option>
                      <Option value={1}
                        disabled={Number(IdentificacaoEscola?.schoolZone) === 1 ? true : false}
                      >Área de assentamento</Option>
                      <Option value={2}>Terra indígena</Option>
                      <Option value={3}>Área onde se localiza comunidade remanescente de quilombos</Option>
                      <Option value={7}>Não está em área de localização diferenciada</Option>
                    </Select>
                    <Message>{errors.localizationSchool?.message}</Message>
                  </Box40>
                </Box3Items>
                <Box>
                  <TitleFieldForm>
                    19 - Dependencias administrativa <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Select
                    name="administrativeDependency"
                    {...register("administrativeDependency")}
                    {...setValue('administrativeDependency', IdentificacaoEscola?.administrativeDependency ?? 0)}
                    defaultValue={IdentificacaoEscola?.administrativeDependency ?? 0}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, administrativeDependency: Number(e.target.value) })}>
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={1}>Federal</Option>
                    <Option value={2}>Estadual</Option>
                    <Option value={3}>Municipal</Option>
                    <Option disabled={IdentificacaoEscola?.isPrivate ? 'none' : 'block'} value={4}>Privada</Option>
                  </Select>
                  <Message>{errors.administrativeDependency?.message}</Message>
                </Box>
                <Box style={{ display: IdentificacaoEscola?.isPrivate ? 'none' : 'block' }}>
                  <TitleFieldForm>
                    20 -  Órgão que a escola publica está vinculada
                  </TitleFieldForm>
                  <Checkbox
                    name='linkedInstitutions[0]'
                    setValue={setValue('linkedInstitutions[0]', IdentificacaoEscola?.linkedInstitutions.secretaryMinistryEducation ?? '0')}
                    register={register('linkedInstitutions[0]')}
                    checked={IdentificacaoEscola?.linkedInstitutions.secretaryMinistryEducation === 1 ? true : false}
                    title='Secretária de Educação/Ministério da Educação.'
                    disabled={Number(IdentificacaoEscola?.administrativeDependency) === 4 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, linkedInstitutions: {
                        ...IdentificacaoEscola?.linkedInstitutions,
                        secretaryMinistryEducation: e.target.checked ? 1 : 0
                      }
                    }
                    )} />
                  <Checkbox
                    name='linkedInstitutions[1]'
                    setValue={setValue('linkedInstitutions[1]', IdentificacaoEscola?.linkedInstitutions.secretarySecurityArmedForce ?? '0')}
                    register={register('linkedInstitutions[1]')}
                    checked={IdentificacaoEscola?.linkedInstitutions.secretarySecurityArmedForce === 1 ? true : false}
                    title='Secretária de Segurança Pública/Forças Armadas Militar.'
                    disabled={Number(IdentificacaoEscola?.administrativeDependency) === 4 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, linkedInstitutions: {
                        ...IdentificacaoEscola?.linkedInstitutions,
                        secretarySecurityArmedForce: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name='linkedInstitutions[2]'
                    setValue={setValue('linkedInstitutions[2]', IdentificacaoEscola?.linkedInstitutions.secretaryMinistryHealth ?? '0')}
                    register={register('linkedInstitutions[2]')}
                    title='Secretária da Saúde/Ministério da Saúde.'
                    checked={IdentificacaoEscola?.linkedInstitutions.secretaryMinistryHealth === 1 ? true : false}
                    disabled={Number(IdentificacaoEscola?.administrativeDependency) === 4 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, linkedInstitutions: {
                        ...IdentificacaoEscola?.linkedInstitutions,
                        secretaryMinistryHealth: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name='linkedInstitutions[3]'
                    setValue={setValue('linkedInstitutions[3]', IdentificacaoEscola?.linkedInstitutions.otherPublicBody ?? '0')}
                    register={register('linkedInstitutions[3]')}
                    checked={IdentificacaoEscola?.linkedInstitutions.otherPublicBody === 1 ? true : false}
                    title='Outro órgão da administração pública.'
                    disabled={Number(IdentificacaoEscola?.administrativeDependency) === 4 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, linkedInstitutions: {
                        ...IdentificacaoEscola?.linkedInstitutions,
                        otherPublicBody: Number(e.target.checked ? 1 : 0)
                      }
                    })} />
                  <Message>{errors.linkedInstitutions?.message}</Message>
                </Box>
                <Box style={{
                  marginTop: 10, display: (Number(IdentificacaoEscola?.workingSituation) === 1
                    && Number(IdentificacaoEscola?.administrativeDependency) === 4) ? 'block' : 'none'
                }}>
                  <TitleFieldForm>
                    21 - Categoria da escola privada
                  </TitleFieldForm>
                  <Select
                    name='privateSchoolCategory'
                    register={register('privateSchoolCategory')}
                    {...setValue('privateSchoolCategory', IdentificacaoEscola?.privateSchoolCategory ?? 0)}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, privateSchoolCategory: e.target.value })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={1}>Particular</Option>
                    <Option value={2}>Comunitária</Option>
                    <Option value={3}>Confessional</Option>
                    <Option value={4}>Filantrópica</Option>
                  </Select>
                  <Message>{errors.privateSchoolCategoryte?.message}</Message>
                </Box>
                <Box style={{ display: Number(IdentificacaoEscola?.workingSituation) === 1 ? 'block' : 'none', marginBottom: 10 }}>
                  <TitleFieldForm>
                    22 - Poder público responsável pela parceria ou convênio entre a Administração Pública e outras instituições
                  </TitleFieldForm>
                  <Checkbox
                    number="partnerPublicPowers[0]"
                    setValue={setValue('partnerPublicPowers[0]', (IdentificacaoEscola?.partnerPublicPowers.stateSecretary === 1 ? 1 : 0))}
                    register={register("partnerPublicPowers[0]")}
                    title='Secretária Estadual'
                    value={1}
                    checked={IdentificacaoEscola?.partnerPublicPowers.stateSecretary === 1 ? true : false}
                    onChange={e => {
                      setIdentificacaoEscola({
                        ...IdentificacaoEscola, partnerPublicPowers:
                          IsNone(IdentificacaoEscola?.partnerPublicPowers, 'stateSecretary')
                        , formContractingPartnershipMunicipalDepartmentEducation:
                          resetValues(IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation)
                      })
                    }} />
                  <Checkbox
                    number="partnerPublicPowers[1]"
                    setValue={setValue('partnerPublicPowers[1]', (IdentificacaoEscola?.partnerPublicPowers.municipalSecretary === 1 ? 2 : 0))}
                    register={register("partnerPublicPowers[1]")}
                    title='Secretária Municipal'
                    value={2}
                    disabled={Number(IdentificacaoEscola?.city) === 5300108}
                    checked={IdentificacaoEscola?.partnerPublicPowers.municipalSecretary === 1 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, partnerPublicPowers:
                        IsNone(IdentificacaoEscola?.partnerPublicPowers, 'municipalSecretary'),
                      formContractingPartnershipStateDepartmentEducation:
                        resetValues(IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation)
                    })} />
                  <Checkbox
                    number="partnerPublicPowers[2]"
                    value={3}
                    setValue={setValue('partnerPublicPowers[2]', (IdentificacaoEscola?.partnerPublicPowers.nonePPP === 1 ? 3 : 0))}
                    register={register("partnerPublicPowers[2]")}
                    title='Não possui parceria ou convênio'
                    checked={IdentificacaoEscola?.partnerPublicPowers.nonePPP === 1 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, partnerPublicPowers:
                        IsNone(IdentificacaoEscola?.partnerPublicPowers, 'nonePPP')
                      , formContractingPartnershipMunicipalDepartmentEducation:
                        resetValues(IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation),
                      formContractingPartnershipStateDepartmentEducation:
                        resetValues(IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation)
                    })} />
                  <Message>{errors.partnerPublicPowers?.message}</Message>
                </Box>
                <Box style={{ marginBottom: 10, display: IdentificacaoEscola?.partnerPublicPowers.stateSecretary === 1 ? 'block' : 'none' }}>
                  <TitleFieldForm>
                    23 - Forma(s) de contratação da parceria ou convênio entre a escola e a Secretaria Estadual de educação.
                  </TitleFieldForm>

                  <Checkbox
                    name="formContractingPartnershipStateDepartmentEducation[4]"
                    setValue={setValue('formContractingPartnershipStateDepartmentEducation[4]', IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation.financialTechnicalCooperationTermFCPSDE ?? 0)}
                    register={register("formContractingPartnershipStateDepartmentEducation[4]")}
                    title='Termo de cooperação técnica e financeira'
                    style={{ display: IdentificacaoEscola?.privateSchoolCategory !== 1 ? 'block' : 'none' }}
                    checked={IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation.financialTechnicalCooperationTermFCPSDE === 1 ? true : false}
                    onChange={e => {
                      setIdentificacaoEscola({
                        ...IdentificacaoEscola, formContractingPartnershipStateDepartmentEducation: {
                          ...IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation,
                          financialTechnicalCooperationTermFCPSDE: e.target.checked ? 1 : 0
                        }
                      });
                    }} />
                  <Checkbox
                    name="formContractingPartnershipStateDepartmentEducation[5]"
                    setValue={setValue('formContractingPartnershipStateDepartmentEducation[5]', IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation.consortiumContractFCPSDE ?? 0)}
                    register={register("formContractingPartnershipStateDepartmentEducation[5]")}
                    checked={IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation.consortiumContractFCPSDE === 1 ? true : false}
                    title='Contrato de consórcio público/Convênio de cooperação'
                    style={{ display: IdentificacaoEscola?.privateSchoolCategory !== 1 ? 'block' : 'none' }}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, formContractingPartnershipStateDepartmentEducation: {
                        ...IdentificacaoEscola?.formContractingPartnershipStateDepartmentEducation,
                        consortiumContractFCPSDE: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Message>{errors.formContractingPartnershipStateDepartmentEducation?.message}</Message>
                </Box>
                <Box style={{ marginBottom: 10, display: IdentificacaoEscola?.partnerPublicPowers.municipalSecretary === 1 ? 'block' : 'none' }}>
                  <TitleFieldForm>

                    23 - Forma(s) de contratação da parceria ou convênio entre a escola e a Secretaria municipal de educação.
                  </TitleFieldForm>

                  <Checkbox
                    name="formContractingPartnershipMunicipalDepartmentEducation[4]"
                    setValue={setValue('formContractingPartnershipMunicipalDepartmentEducation[4]', IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation.financialTechnicalCooperationTermFCPMDE ?? 0)}
                    register={register("formContractingPartnershipMunicipalDepartmentEducation[4]")}
                    title='Termo de cooperação técnica e financeira'
                    style={{ display: IdentificacaoEscola?.privateSchoolCategory !== 1 ? 'block' : 'none' }}
                    checked={IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation.financialTechnicalCooperationTermFCPMDE === 1 ? true : false}
                    onChange={e => {
                      setIdentificacaoEscola({
                        ...IdentificacaoEscola, formContractingPartnershipMunicipalDepartmentEducation: {
                          ...IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation,
                          financialTechnicalCooperationTermFCPMDE: e.target.checked ? 1 : 0
                        }
                      });
                    }} />
                  <Checkbox
                    name="formContractingPartnershipMunicipalDepartmentEducation[5]"
                    setValue={setValue('formContractingPartnershipMunicipalDepartmentEducation[5]', IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation.consortiumContractFCPMDE ?? 0)}
                    register={register("formContractingPartnershipMunicipalDepartmentEducation[5]")}
                    checked={IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation.consortiumContractFCPMDE === 1 ? true : false}
                    title='Contrato de consórcio público/Convênio de cooperação'
                    style={{ display: IdentificacaoEscola?.privateSchoolCategory !== 1 || IdentificacaoEscola?.privateSchoolCategory !== null ? 'block' : 'none' }}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, formContractingPartnershipMunicipalDepartmentEducation: {
                        ...IdentificacaoEscola?.formContractingPartnershipMunicipalDepartmentEducation,
                        consortiumContractFCPMDE: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Message>{errors.formContractingPartnershipMunicipalDepartmentEducation?.message}</Message>
                </Box>
                <Box style={{
                  marginBottom: 10, display: Number(IdentificacaoEscola?.workingSituation) === 1
                    && Number(IdentificacaoEscola?.administrativeDependency) === 4 ? 'block' : 'none'
                }}>
                  <TitleFieldForm>  24 - Mantenedora da escola privada</TitleFieldForm>
                  <Checkbox
                    name="privateSchoolMaintainers[0]"
                    setValue={setValue('privateSchoolMaintainers[0]', IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson ?? '0')}
                    register={register("privateSchoolMaintainers[0]")}
                    checked={IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson === 1 ? true : false}
                    title='Empresa ou grupo empresarial do setor privado ou pessoa física.'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, privateSchoolMaintainers: {
                        ...IdentificacaoEscola?.privateSchoolMaintainers,
                        companiesPhysicalPerson: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name="privateSchoolMaintainers[1]"
                    setValue={setValue('privateSchoolMaintainers[1]', IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson ?? '0')}
                    register={register("privateSchoolMaintainers[1]")}
                    title='Instituição sem fins lucrativos.'
                    checked={IdentificacaoEscola?.privateSchoolMaintainers.unionsAssociations === 1 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, privateSchoolMaintainers: {
                        ...IdentificacaoEscola?.privateSchoolMaintainers,
                        unionsAssociations: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name="privateSchoolMaintainers[2]"
                    setValue={setValue('privateSchoolMaintainers[2]', IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson ?? '0')}
                    register={register("privateSchoolMaintainers[2]")}
                    checked={IdentificacaoEscola?.privateSchoolMaintainers.nonProfitInstitution === 1 ? true : false}
                    title='Sindicatos de trabalhadores ou patronais, associações, cooperativas.'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, privateSchoolMaintainers: {
                        ...IdentificacaoEscola?.privateSchoolMaintainers,
                        nonProfitInstitution: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name="privateSchoolMaintainers[3]"
                    setValue={setValue('privateSchoolMaintainers[3]', IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson ?? '0')}
                    register={register("privateSchoolMaintainers[3]")}
                    checked={IdentificacaoEscola?.privateSchoolMaintainers.systemS === 1 ? true : false}
                    title='Sistema S (Sesi, Senai, Sesc, outros).'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, privateSchoolMaintainers: {
                        ...IdentificacaoEscola?.privateSchoolMaintainers,
                        systemS: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name="privateSchoolMaintainers[4]"
                    setValue={setValue('privateSchoolMaintainers[4]', IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson ?? '0')}
                    register={register("privateSchoolMaintainers[4]")}
                    checked={IdentificacaoEscola?.privateSchoolMaintainers.ong === 1 ? true : false}
                    title='Organização não governamental (ONG) - nacional ou internacional.'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, privateSchoolMaintainers: {
                        ...IdentificacaoEscola?.privateSchoolMaintainers,
                        ong: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Checkbox
                    name="privateSchoolMaintainers[5]"
                    setValue={setValue('privateSchoolMaintainers[5]', IdentificacaoEscola?.privateSchoolMaintainers.companiesPhysicalPerson ?? '0')}
                    register={register("privateSchoolMaintainers[5]")}
                    checked={IdentificacaoEscola?.privateSchoolMaintainers.oscip === 1 ? true : false}
                    title='Organização da Sociedade Civil de Interesse Público (OSCIP).'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, privateSchoolMaintainers: {
                        ...IdentificacaoEscola?.privateSchoolMaintainers,
                        oscip: e.target.checked ? 1 : 0
                      }
                    })} />
                  <Message>{errors.privateSchoolMaintainers?.message}</Message>
                </Box>
                <Box3Items>
                  <Box50 style={{
                    display: (Number(IdentificacaoEscola?.workingSituation) === 1
                      && Number(IdentificacaoEscola?.administrativeDependency) === 4
                      && Number(IdentificacaoEscola?.regulation) === 1) ? 'block' : 'none'
                  }}>
                    <InputResponsive1
                      name="cnpjMaintainer"
                      maxlength='18'
                      value={cnpjMask(IdentificacaoEscola?.cnpjMaintainer) ?? ''}
                      register={register('cnpjMaintainer')}
                      {...setValue('cnpjMaintainer', IdentificacaoEscola?.cnpjMaintainer ?? null)}
                      title="26 - CNPJ da mantenedora principal da escola privada"
                      erro={errors.cnpjMaintainer?.message}
                      onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, cnpjMaintainer: e.target.value })}
                    />
                  </Box50>
                </Box3Items>
                <Box3Items>
                  <Box50 style={{
                    display: (Number(IdentificacaoEscola?.workingSituation) === 1
                      && Number(IdentificacaoEscola?.administrativeDependency) === 4) ? 'block' : 'none'
                  }}>
                    <InputResponsive1
                      name="cnpj"
                      maxlength='18'
                      value={cnpjMask(IdentificacaoEscola?.cnpj) ?? 0}
                      style={{
                        display: (Number(IdentificacaoEscola?.workingSituation) === 1
                          && Number(IdentificacaoEscola?.administrativeDependency) === 4) ? 'block' : 'none'
                      }}
                      register={register('cnpj')}
                      {...setValue('cnpj', IdentificacaoEscola?.cnpj ?? 0)}
                      erro={errors.cnpj?.message}
                      title="27 - Número do CNPJ da escola privada"
                      onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, cnpj: e.target.value })}
                    />
                  </Box50>
                </Box3Items>
                <Box style={{ display: Number(IdentificacaoEscola?.workingSituation) === 1 ? 'block' : 'none' }}>
                  <TitleFieldForm>
                    28 - Regulamentação/Autorização no conselho ou órgão municipal, estadual ou federal de educação

                  </TitleFieldForm>
                  <Select
                    name="regulation"
                    {...register('regulation')}
                    {...setValue('regulation', IdentificacaoEscola?.regulation ?? 0)}
                    erro={errors.regulation?.message}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, regulation: e.target.value,
                      spheresRegulatoryInstitution: resetValues(IdentificacaoEscola?.spheresRegulatoryInstitution)
                    })}
                  >
                    <Option value={-1} disabled hidden>selecione</Option>
                    <Option value={0}>Não</Option>
                    <Option value={1}>Sim</Option>
                    <Option value={2}>Em tramitação</Option>
                  </Select>
                  <Message>{errors.regulation?.message}</Message>
                </Box>

                <Box style={{
                  display: (Number(IdentificacaoEscola?.regulation) !== 0) ? "block" : 'none'
                }} >
                  <TitleFieldForm>
                    29 - Esfera administrativa do conselho no orgão responsavel pela regulamentação/Autorização
                  </TitleFieldForm>
                  <Checkbox
                    name="spheresRegulatoryInstitution[0]"
                    register={register('spheresRegulatoryInstitution[0]')}
                    setValue={setValue('spheresRegulatoryInstitution[0]', IdentificacaoEscola?.spheresRegulatoryInstitution.federal)}
                    style={{
                      display: (Number(IdentificacaoEscola?.regulation) !== 0) &&
                        (Number(IdentificacaoEscola?.administrativeDependency) !== 2
                          || Number(IdentificacaoEscola?.administrativeDependency) !== 3) ? "block" : 'none'
                    }}
                    checked={IdentificacaoEscola?.spheresRegulatoryInstitution.federal === 1 ? true : false}
                    title='Federal'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, spheresRegulatoryInstitution: {
                        ...IdentificacaoEscola?.spheresRegulatoryInstitution,
                        federal: e.target.checked ? 1 : 0,
                        municipal: 0
                      }
                    })}
                  />
                  <Checkbox
                    name="spheresRegulatoryInstitution[1]"
                    setValue={setValue('spheresRegulatoryInstitution[1]', IdentificacaoEscola?.spheresRegulatoryInstitution.state ?? null)}
                    register={register('spheresRegulatoryInstitution[1]')}
                    title='Estadual'
                    checked={IdentificacaoEscola?.spheresRegulatoryInstitution.state === 1 ? true : false}
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, spheresRegulatoryInstitution: {
                        ...IdentificacaoEscola?.spheresRegulatoryInstitution,
                        state: e.target.checked ? 1 : 0
                      }
                    })}
                    disabled={Number(IdentificacaoEscola?.regulation) === 0
                      ? true : false} />
                  <Checkbox
                    style={{
                      display: Number(IdentificacaoEscola?.address.city) !== 5300108 ? "block" : 'none'
                    }}
                    name="spheresRegulatoryInstitution[2]"
                    setValue={setValue('spheresRegulatoryInstitution[2]', IdentificacaoEscola?.spheresRegulatoryInstitution.municipal)}
                    register={register('spheresRegulatoryInstitution[2]')}
                    checked={IdentificacaoEscola?.spheresRegulatoryInstitution.municipal === 1 ? true : false}
                    title='Municipal'
                    onChange={e => setIdentificacaoEscola({
                      ...IdentificacaoEscola, spheresRegulatoryInstitution: {
                        ...IdentificacaoEscola?.spheresRegulatoryInstitution,
                        municipal: e.target.checked ? 1 : 0,
                        federal: 0
                      }
                    })}
                    disabled={Number(IdentificacaoEscola?.regulation) === 0
                      || Number(IdentificacaoEscola?.administrativeDependency) === 1
                      || Number(IdentificacaoEscola?.administrativeDependency) === 2 ? true : false} />
                  <Message>{errors.spheresRegulatoryInstitution?.message}</Message>
                </Box>
                <Box style={{ marginTop: 10, marginBottom: 10, display: Number(IdentificacaoEscola?.workingSituation) === 1 ? 'block' : 'none' }}>
                  <TitleFieldForm>
                    30 - Unidade vinculada à escola de educação básica ou unidade ofertante de educação superior
                  </TitleFieldForm>
                  <Select
                    name='bindingUnit'
                    {...setValue('bindingUnit', IdentificacaoEscola?.bindingUnit ?? -1)}
                    {...register('bindingUnit')}
                    onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, bindingUnit: e.target.value })}
                  >
                    <Option value={-1} disabled hidden>selecione</Option>
                    <Option value={1}>Unidade vinculada a escola de educação básica</Option>
                    <Option value={2}>Unidade ofertante de educação Superior</Option>
                    <Option value={0}>Sem vinculo com outra instituição</Option>
                  </Select>

                  <Message>{errors.bindingUnit?.message}</Message>
                </Box>
                <Box3Items>
                  <Box40 style={{ display: Number(IdentificacaoEscola?.bindingUnit) === 1 ? 'block' : 'none' }}>
                    <InputResponsive1
                      name='codeSchoolHeadquarters'
                      register={register('codeSchoolHeadquarters')}
                      title="30a: Codigo da Escola sede"
                      {...setValue('codeSchoolHeadquarters', IdentificacaoEscola?.codeSchoolHeadquarters ?? 0)}
                      erro={errors.codeSchoolHeadquarters?.message}
                      onChange={e => setIdentificacaoEscola({ ...IdentificacaoEscola, codeSchoolHeadquarters: e.target.value })}
                    />
                  </Box40>
                </Box3Items>
                <Box3Items style={{ display: Number(IdentificacaoEscola?.bindingUnit) === 2 ? 'block' : 'none' }} >
                  <Box40>
                    <TitleFieldForm>
                      31 -Código da Instituição de Educação Superior(IES)
                    </TitleFieldForm>
                    <Select
                      value={IdentificacaoEscola?.codeIES ?? 0}
                      onChange={(e) => { setIdentificacaoEscola({ ...IdentificacaoEscola, codeIES: e.target.value }) }}
                    >
                      <Option key={0} value={0}>Selecione</Option>
                      {
                        ies?.map((item, index) => {
                          return <Option key={item.name + index} value={item.id}>{item.name}-{item.state}</Option>
                        })
                      }
                    </Select>
                  </Box40>
                </Box3Items>
              </BoxInput>
              <ButtonFormFooter
                textNext="Próximo"
                linkBack={"/home"}
              />
            </FormContent>
          </form>
        </Container>
      </App >
    </>
  )

}
export default IdentificacaoEscola;